"use client";

import type { Interpolation } from "@emotion/react";
import { appendSearchParamToUrl, URL_ONBOARDING } from "@packages/sdk";
import { cssMediaQueryMinWidthTablet, spacing } from "@packages/ui/emotion";
import { AuthMainFlow } from "@packages/ui/src/components/blocks/auth/AuthMainFlow.emotion";
import type { AuthFlowProps } from "@packages/ui/src/components/blocks/auth/AuthTypes.emotion";
import { useRouter } from "next/navigation";

const legalCSS: Interpolation = {
  paddingTop: spacing.xxl,
  [cssMediaQueryMinWidthTablet]: {
    paddingTop: spacing.ml,
  },
};

export const AuthClient = () => {
  const router = useRouter();

  const handleAuth: AuthFlowProps["onAuth"] = ({ data }) => {
    if (data?.is_new && !data?.user.subscription) {
      router.push(
        `/upgrade/subscribe?redirect=${encodeURIComponent(`/home?welcome=true`)}`,
      );
      return;
    }
    if (data?.is_new) {
      router.push(
        appendSearchParamToUrl({
          key: "welcome",
          url: "/home",
          value: "true",
        }) || URL_ONBOARDING,
      );
    } else {
      router.push("/home");
    }
  };

  return (
    <AuthMainFlow
      setFlow={(flow) =>
        router.push(`/login?flow=${flow}&checkSubscription=true`)
      }
      onAuth={handleAuth}
      flow="main"
      allowedMethods={["email", "phone", "apple", "google"]}
      legalCSS={legalCSS}
    />
  );
};
